import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useRelatedRecipes } from '@/hooks/useRelatedRecipes';
import { useLanguage } from '@/context/LanguageContext';

const RecipeNavigation = ({ recipe, lang }) => {
  const { data: related } = useRelatedRecipes(recipe, lang);
  const { getLocalizedPath } = useLanguage();

  if (!related || related.length < 2) return null;

  const prev = related[0];
  const next = related[1];

  return (
    <nav className="flex justify-between items-stretch gap-4 mt-8 pt-6 border-t border-border/50" data-testid="recipe-nav">
      <Link
        to={getLocalizedPath(`/recipe/${prev.slug}`)}
        className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors group max-w-[45%]"
        data-testid="prev-recipe-link"
      >
        <ChevronLeft className="h-4 w-4 flex-shrink-0 group-hover:-translate-x-0.5 transition-transform" />
        <span className="truncate">{prev.recipe_name}</span>
      </Link>
      <Link
        to={getLocalizedPath(`/recipe/${next.slug}`)}
        className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors group max-w-[45%] text-right ml-auto"
        data-testid="next-recipe-link"
      >
        <span className="truncate">{next.recipe_name}</span>
        <ChevronRight className="h-4 w-4 flex-shrink-0 group-hover:translate-x-0.5 transition-transform" />
      </Link>
    </nav>
  );
};

export default RecipeNavigation;
